import { getIsReportValidForDimensionEditorDropdown } from './utils';
import { isConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import ConfigReportDimensionEditorDropdown from './config-report/ConfigReportDimensionEditorDropdown';
import RelationalReportDimensionEditorDropdown from './relational-report/RelationalReportDimensionEditorDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
const DimensionEditorDropdown = props => {
  const {
    report
  } = props;
  if (getIsReportValidForDimensionEditorDropdown({
    report
  })) {
    if (isConfigReport(report)) {
      return /*#__PURE__*/_jsx(ConfigReportDimensionEditorDropdown, Object.assign({}, props, {
        report: report
      }));
    } else if (isRelationalReport(report)) {
      return /*#__PURE__*/_jsx(RelationalReportDimensionEditorDropdown, Object.assign({}, props, {
        report: report
      }));
    }
  }
  return null;
};
export default DimensionEditorDropdown;